import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import BlogDetail from "@/pages/BlogDetail";
import Imprint from "@/pages/Imprint";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CookieBanner from "@/components/CookieBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminBlogList from "@/pages/admin/AdminBlogList";
import AdminBlogEdit from "@/pages/admin/AdminBlogEdit";
import TraineeConsultant from "@/pages/TraineeConsultant";
import DefenseSecurity from "@/pages/DefenseSecurity";
import SupplyChain from "@/pages/SupplyChain";
import IndustrialAI from "@/pages/IndustrialAI";
import ProcessOptimization from "@/pages/ProcessOptimization";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect OAuth callback synchronously during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/insights/:slug" element={<BlogDetail />} />
      <Route path="/impressum" element={<Imprint />} />
      <Route path="/datenschutz" element={<Privacy />} />
      <Route path="/agb" element={<Terms />} />
      <Route path="/karriere/trainee-consultant" element={<TraineeConsultant />} />
      <Route path="/leistungen/defense-security" element={<DefenseSecurity />} />
      <Route path="/leistungen/supply-chain-nearshoring" element={<SupplyChain />} />
      <Route path="/leistungen/industrial-ai-robotics" element={<IndustrialAI />} />
      <Route path="/leistungen/prozessoptimierung" element={<ProcessOptimization />} />

      {/* Admin */}
      <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/callback" element={<AuthCallback />} />
      <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/contacts" element={<AdminContacts />} />
        <Route path="/admin/blog" element={<AdminBlogList />} />
        <Route path="/admin/blog/new" element={<AdminBlogEdit />} />
        <Route path="/admin/blog/:id/edit" element={<AdminBlogEdit />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <AppRouter />
              <CookieBanner />
            </BrowserRouter>
            <Toaster position="bottom-right" richColors />
          </div>
        </AuthProvider>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
